import { Pipe, PipeTransform } from '@angular/core';
import { humanizeLabel } from '../_utils/format-label';

@Pipe({
  name: 'humanize'
})
export class HumanizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return humanizeLabel(value);
  }
}
